import { FormControl, Grid, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import CkMuiDialog from "./CkMuiDialog/CkMuiDialog";
import ChefForPartyService from "../../services/ChefForPartyService";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "./CustomSnackBar";


const partyService = new ChefForPartyService();

interface InputProps {
  isOpen: boolean;
  data: any;
  setPriceData: (data : any) => void;
  setIsOpen: (isOpen: boolean) => void;
  refresh: () => void;
}

const AddPartyQuotedPrice = ({
  isOpen,
  setIsOpen,
  setPriceData,
  data,
  refresh,
}: InputProps) => {
  const {partyId, cookId, previousPrice} = data || {}; 
  let [price, setPrice] = useState(previousPrice);

  useEffect(()=>{
    setPrice(previousPrice)
  },[previousPrice])

  let handleClose = () => {
      setPrice('');
      setIsOpen(false);
  };
  const handleSubmit = () => {
    partyService.addQuotedPrice(partyId,{
        cookId,
        quotedCookCut: price
    }).then((res)=>{
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Comment Added Successfully",
            type: CustomSnackbarTypes.SUCCESS,
        });
    }).catch((err)=>{
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Something Went Wrong",
            type: CustomSnackbarTypes.ERROR,
        });
    }).finally(() => {
        setIsOpen(false);
        setPrice('');
        setPriceData(null);
        refresh();
      });
  };
  return (
    <CkMuiDialog
      isDialogOpen={isOpen}
      setDialogOpen={setIsOpen}
      onDialogClose={handleClose}
      title={"Add Price"}
      primaryLabel={"Submit"}
      primaryAction={handleSubmit}
      secondaryLabel={"Close"}
      secondaryAction={() => {
        setIsOpen(false);
        setPrice('');
        setPriceData(null);
      }}
      isLoading={false}
      fullWidth={true}
    >
    <Grid
        container
        spacing={2}
        justifyContent={"space-evenly"}
        style={{ padding: "12px 12px 12px 12px" }}
        direction="column"
        alignItems="center"
    >
        <Grid item xs={12}>
            <FormControl style={{ width: 500 }}>
                <TextField onChange={(e)=> setPrice(e.target.value)} placeholder="Enter quoted price" value={price}/>
            </FormControl>
        </Grid>
    </Grid>
    </CkMuiDialog>
  );
};

export default AddPartyQuotedPrice;